import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z
  .object({
    title: z.string().min(1, t('pages.application_indications_map.components.location_create_modal.schema.required')),
    description: z.string().optional(),
    address: z.object({
      postal_code: z.string().min(1, t('pages.application_indications_map.components.location_create_modal.schema.required')),
      line1: z.string().optional(),
      line2: z.string().optional(),
      line3: z.string().optional(),
      neighborhood: z.string().optional(),
      city: z.string().optional(),
      state: z.string().optional(),
      country_code: z.string().optional(),
    }),
    phone_number: z.string().optional(),
    email: z.string().optional(),
    website: z.string().optional(),
    team_uuid: z.string().optional(),
    instagram: z.string().optional(),
    image: z.any().optional(),
    latitude: z.preprocess(val => (val === '' ? undefined : Number(val)), z.number().optional()),
    longitude: z.preprocess(val => (val === '' ? undefined : Number(val)), z.number().optional()),
  })
  .superRefine((values, ctx) => {
    if (!values.image) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['image'],
        message: t('pages.application_indications_map.components.location_create_modal.schema.required_image'),
      });
    }
  });

export type ModalFormData = z.infer<typeof modalFormSchema>;
